import React from "react";


const Person = ({ name, image, responsibilities, hobbies }) => {
  return (
    <div className="row">
      <div className="col-5">
        <img src={image} className="img-fluid" alt={`Portrait von ${name}`}/>
        <br />
        <h2>{name}</h2>
      </div>
      <div className="col-7">
        <h4>zuständig für:</h4>
        {responsibilities.map((responsibility) => (
          <p key={responsibility}>{responsibility}</p>
        ))}
        <h4>Hobbies:</h4>
        {hobbies.map((hobby) => (
          <p key={hobby}>{hobby}</p>
        ))}
      </div>
    </div>
  );
};

export default Person;
